import { useState } from 'react';

import { FeatureGate } from '@/routes/FeatureGate';

import { CommunityFab } from './CommunityFab';
import { ReadOnlyBanner } from './ReadOnlyBanner';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { WorkflowStepper } from './WorkflowStepper';

/** Kerangka halaman untuk seluruh rute yang memerlukan autentikasi. */
export function AppLayout() {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-dvh bg-[var(--color-background)]">
      <div className="app-shell-sidebar">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
      </div>

      {/* Margin kiri hanya di layar besar, tempat sidebar selalu terlihat. */}
      <div className="lg:pl-64 app-shell-content">
        <div className="app-shell-topbar">
          <Topbar onOpenSidebar={() => setSidebarOpen(true)} />
        </div>

        <main className="p-4 lg:p-6 app-shell-main">
          <ReadOnlyBanner />
          {/* Penunjuk langkah alur Rapor / SKTB — hanya muncul di halaman
              yang termasuk salah satu alurnya. */}
          <WorkflowStepper />
          {/* Halaman modul yang tidak dibeli lembaga dicegat di sini, sebelum
              komponennya dimuat dan menembak API yang pasti menolaknya. */}
          <FeatureGate />
        </main>
      </div>

      {/* Di kerangka, bukan di satu halaman: ajakan ini menemani seluruh
          dashboard lembaga. Portal Wali Murid memakai kerangkanya sendiri
          (PortalLayout), jadi ia tidak pernah sampai ke layar wali — dan
          pengguna tanpa lembaga (Super Admin, Dinas) disaring di dalam
          komponennya. */}
      <CommunityFab />
    </div>
  );
}
